import type { CheckoutProps } from "../CheckoutProps";
import { getPaywallTitle } from "../helpers/paywalls";

export const useCheckoutTitle = ({ paywall }: CheckoutProps) =>
  getPaywallTitle(paywall);
